<template>

</template>

<script>
  export default {
    inject: ['registerHandler'],
    props: {
      slug: {
        type: String,
        required: true,
      },
    },
    created() {
      this.registerHandler(this);
    },
    methods: {
      validate() {
        return true;
      },
      getData() {
        return [];
      }
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/shipping/NoneShippingHandler.vue